<script context="module">
  import PageHead from "./../Components/PageHead.svelte";
  import Breadcrumb from "./Partials/Breadcrumb.svelte";
  import Dollar from "../Components/Dollar.svelte";
  export { default as layout } from "../Shared/Layout.svelte";
</script>

<script>
  import Feedback from "./Partials/Feedback.svelte";

  export let renewal;

  function printReceipt() {
    window.print();
  }
</script>

<PageHead>
  <svelte:fragment slot="title">Payment Complete</svelte:fragment>
  <svelte:fragment slot="tagline">
    Your receipt is below. Please retain this for your records.
  </svelte:fragment>
  <Breadcrumb slot="breadcrumb">
    <span slot="home"></span>
    <span slot="receipt"></span>
  </Breadcrumb>
</PageHead>

<div class="row">
  <div class="col-md-8 col-print-12 order-1 order-md-0">
    <div class="card">
      <div class="card-header">
        <h4 class="mb-0 text-primary">Payment Details</h4>
      </div>
      <div class="card-body">
        <div class="list-group list-group-flush">
          <div class="list-group-item">
            <div class="row align-items-center">
              <h6 class="col-7 mb-0">Payment Method</h6>
              <h6 class="col-5 mb-0">
                {renewal.payment_method === "e"
                  ? "Electronic Check"
                  : "Credit Card"}
              </h6>
            </div>
          </div>
          <div class="list-group-item">
            <div class="row align-items-center">
              <h6 class="col-7 mb-0">Amount Paid</h6>
              <h6 class="col-5 mb-0">
                <Dollar value={renewal.amount} className="" />
              </h6>
            </div>
          </div>
          <div class="list-group-item">
            <div class="row align-items-center">
              <h6 class="col-7 mb-0">Order Date/Time</h6>
              <h6 class="col-5 mb-0">
                {renewal.order_timestamp}
              </h6>
            </div>
          </div>
          <div class="list-group-item">
            <div class="row align-items-center">
              <h6 class="col-7 mb-0">Confirmation Number (Order ID)</h6>
              <h6 class="col-5 mb-0">
                {renewal.orderid}
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4 d-print-none d-grid order-0 order-md-1">
    <div>
      <button
        class="btn btn-primary btn-lg d-print-none d-block w-100"
        on:click={printReceipt}>Print Receipt</button
      >
    </div>
    <div class="card my-4 my-md-0">
      <div class="card-header">
        <h4 class="mb-0 text-primary">How was your experience?</h4>
      </div>
      <div class="card-body">
        <Feedback />
      </div>
    </div>
  </div>

  <div class="col-12 mt-4 order-3">
    <div class="card">
      <div class="card-header">
        <h4 class="mb-0 text-primary">Renewals</h4>
      </div>
      <div class="card-body p-0">
        <table class="table table-hover mb-0">
          <thead>
            <tr>
              <th class="ps-4">Description</th>
              <th>Renewal Period</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {#each renewal.detail as detail}
              <tr>
                <td class="ps-4">
                  {detail.details.registration.VehicleDetail.Year}
                  {detail.details.registration.VehicleDetail.Make}
                  {detail.details.registration.VehicleDetail.Model}<br />
                  {detail.details.registration.VehicleDetail.VIN}
                </td>
                <td>
                  {detail.number_years} Year{detail.number_years > 1 ? "s" : ""}
                  Renewal
                </td>
                <td>
                  <Dollar value={detail.price} className="" />
                </td>
              </tr>
            {/each}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
